import { render, staticRenderFns } from "./LikedUsers.vue?vue&type=template&id=d2d464d6&"
import script from "./LikedUsers.vue?vue&type=script&lang=js&"
export * from "./LikedUsers.vue?vue&type=script&lang=js&"
import style0 from "./LikedUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports